export default "/images/adLib.svg?593738a5c39f86ee7948161b85b21fda";